import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-classic-2, click"><path d="M19 15C19 18.8659 15.866 22 12 22C8.13404 22 5.00005 18.8659 5 15V10.5H19V15Z" fill="currentColor"/><path d="M11.25 9H5V5.75C5.00002 3.67895 6.67895 2 8.75 2H11.25V9Z" fill="currentColor"/><path d="M15.25 2C17.321 2.00003 18.9999 3.67901 19 5.75V9H12.75V2H15.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMouseClassic2;
